import styled from "styled-components";

import { FLIGHT_TYPE_CF } from "../../../constants";

export const Wrapper = styled("div")(({ theme, $isCompact }) => ({
  ...theme.paddings(0, 15),
  ...($isCompact
    ? {
        ...theme.paddings(20, 0),
      }
    : {
        position: "absolute",
        bottom: 100,
        left: 0,
        zIndex: 20,
      }),
  width: "100%",

  [theme.down("sm")]: {
    ...theme.paddings($isCompact ? 20 : 0, 15),
    position: "relative",
    bottom: 0,
  },
}));

export const FormBlock = styled("div")(({ theme, flightType }) => ({
  ...(flightType !== FLIGHT_TYPE_CF ? {} : { flexWrap: "wrap" }),
  display: "flex",
  gap: flightType !== FLIGHT_TYPE_CF ? 1 : 10,

  [theme.down("md")]: {
    flexWrap: "wrap",
    justifyContent: "space-between",
    rowGap: 10,
  },

  [theme.down("sm")]: {
    ...(flightType !== FLIGHT_TYPE_CF ? {} : { rowGap: 20 }),
  },
}));

export const SwapAirportButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  width: 28,
  height: 28,
  border: "1px solid #dfdfdf",
  position: "absolute",
  left: "calc(50% - 14px)",
  top: "calc(50% - 14px)",
  zIndex: 10,
  borderRadius: "50%",
  fontSize: 16,
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.white,
  lineHeight: 1,
  cursor: "pointer",
  transform: "rotate(90deg)",
  boxShadow: "0 2px 6px rgba(0,0,0,.15)",
  transition: "all .2s ease",

  // FE-23: визуально 28px, но палец попадает в 44x44
  "&::after": {
    content: '""',
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: theme.tapTarget,
    height: theme.tapTarget,
  },

  "&:hover": {
    backgroundColor: theme.palette.background.light,
    boxShadow: "0 3px 8px rgba(0,0,0,.2)",
    transform: "rotate(90deg) scale(1.1)",
  },

  "&:active": {
    transform: "rotate(90deg) scale(0.95)",
  },

  [theme.down("sm")]: {
    transform: "none",
  },
}));

export const RouteBlock = styled("div")(({ theme, gap, smGap }) => ({
  display: "flex",
  gap: gap || 1,
  position: "relative",

  [theme.down("sm")]: {
    flexDirection: "column",
    width: "100%",
    gap: smGap || 10,
  },
}));

export const RemoveRouteButton = styled("button")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  width: 22,
  height: 22,
  position: "absolute",
  right: -7,
  top: -7,
  zIndex: 10,
  borderRadius: "50%",
  border: "none",
  fontSize: 16,
  color: theme.palette.white,
  backgroundColor: theme.palette.removeRouteButtonBg,
  lineHeight: 1,
  cursor: "pointer",

  // FE-23: крестик визуально 22px, зона нажатия — 44x44
  "&::after": {
    content: '""',
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: theme.tapTarget,
    height: theme.tapTarget,
  },
}));

export const SearchFormBlock = styled("div")(({ theme }) => ({
  padding: 15,
  borderRadius: 8,
  backgroundColor: theme.palette.white,
  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
}));

export const SelectAirportsFromToBlock = styled("div")(({ theme }) => ({
  display: "flex",
  gap: 1,
  position: "relative",

  [theme.down("sm")]: {
    flexDirection: "column",
    gap: 10,
    width: "100%",
  },
}));

export const AddRouteButton = styled("button")(({ theme, disabled }) => ({
  ...(disabled ? { cursor: "not-allowed", opacity: 0.5 } : { cursor: "pointer" }),
  backgroundColor: "transparent",
  border: "none",
  boxShadow: `2px 2px 5px 0 ${theme.palette.shadow.heavy}`,
  width: 1182,
  height: 60,
  color: theme.palette.white,
  fontSize: 22,
  borderRadius: 4,

  [theme.down("xl")]: {
    width: 922,
  },

  [theme.down("lg")]: {
    width: 762,
  },

  [theme.down("md")]: {
    width: 500,
  },

  [theme.down("sm")]: {
    width: "100%",
  },
}));

export const SearchButtonBlock = styled("div")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  paddingTop: 20,
}));

export const SearchButton = styled("button")(({ theme }) => ({
  ...theme.paddings(0, 24),
  border: "none",
  backgroundColor: theme.palette.searchButtonBg,
  cursor: "pointer",
  height: 52, // FE-10: главное действие — размер L
  ...theme.typography.button,
  fontSize: 18,
  color: theme.palette.white,
  borderRadius: theme.radii.md,
  transition: "all .2s ease",
  // FE-35: тень была красной (rgba(230,57,70)) на оранжевой кнопке — приводим к цвету бренда
  boxShadow: `0 2px 8px ${theme.palette.primary.shadowLight}`,

  "&:hover": {
    backgroundColor: theme.palette.hoverButtonBg,
    boxShadow: `0 4px 12px ${theme.palette.primary.shadowHover}`,
    transform: "translateY(-1px)",
  },

  "&:active": {
    transform: "translateY(0)",
    boxShadow: `0 2px 6px ${theme.palette.primary.shadowLight}`,
  },

  // FE-03: фокус с клавиатуры виден и не сливается с оранжевой заливкой
  "&:focus-visible": {
    outline: `2px solid ${theme.palette.secondary.main}`,
    outlineOffset: 2,
  },

  // FE-35: выключенное состояние отличается от активного не только цветом
  "&:disabled": {
    backgroundColor: theme.palette.button.disabled,
    color: theme.palette.button.disabledText,
    boxShadow: "none",
    cursor: "not-allowed",
    transform: "none",
  },
}));
